if (!customElements.get('compare-table')) {
  customElements.define(
    'compare-table',
    class CompareTable extends HTMLElement {
      connectedCallback() {
        this.markIdenticalRows();

        this.toggle = this.querySelector('.compare__diff-toggle');
        this.toggle?.addEventListener('change', () => {
          this.dataset.diffOnly = this.toggle.checked ? 'true' : 'false';
        });

        this.querySelectorAll('.compare__swatch').forEach((swatch) => {
          swatch.addEventListener('click', () => this.selectSwatch(swatch));
        });
      }

      markIdenticalRows() {
        const rows = {};
        this.querySelectorAll('.compare__cell').forEach((cell) => {
          (rows[cell.dataset.row] ||= []).push(cell);
        });

        Object.entries(rows).forEach(([row, cells]) => {
          const values = cells.map((c) => c.textContent.trim());
          const same = values.length > 1 && values.every((v) => v === values[0]);
          this.querySelectorAll(`[data-row="${row}"]`).forEach((el) => {
            el.dataset.same = same ? 'true' : 'false';
          });
        });
      }

      selectSwatch(swatch) {
        const card = swatch.closest('.compare__product');
        if (!card) return;

        const img = card.querySelector('.compare__img');
        const price = card.querySelector('.compare__price');
        if (img && swatch.dataset.image) img.src = swatch.dataset.image;
        if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;

        card.querySelectorAll('.compare__swatch').forEach((s) => s.classList.remove('is-active'));
        swatch.classList.add('is-active');
      }
    }
  );
}
